"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthDto = void 0;
/**
 * Represents an authentication object containing the owner's address, signature, and hash.
 * Use `AuthDto.fromJson` to create an instance from a JSON object.
 */
class AuthDto {
    /**
     * Creates an instance of AuthDto.
     * @param ownerAddress - The owner's address.
     * @param signature - The owner's signature of the hash.
     * @param hash - The hash of the data to be signed.
     * @param smartWalletAddress - The smart wallet address (optional).
     */
    constructor(ownerAddress, signature, hash, smartWalletAddress) {
        this.ownerAddress = ownerAddress;
        this.signature = signature;
        this.hash = hash;
        this.smartWalletAddress = smartWalletAddress;
    }
    /**
     * Converts the AuthDto object to JSON format.
     * @returns The JSON representation of the AuthDto object.
     */
    toJson() {
        return {
            ownerAddress: this.ownerAddress,
            smartWalletAddress: this.smartWalletAddress,
            signature: this.signature,
            hash: this.hash,
        };
    }
    /**
     * Creates an AuthDto object from a JSON representation.
     * @param json - The JSON representation of the AuthDto object.
     * @returns The AuthDto object.
     */
    static fromJson(json) {
        return new AuthDto(json.ownerAddress, json.signature, json.hash, json.smartWalletAddress);
    }
}
exports.AuthDto = AuthDto;
